module.exports = __webpack_public_path__ + "static/media/page-prev.4b99193b.svg";